export enum AssetListViewType {
  list = 'list',
  column = 'columns',
}

export type AssetListViewTypes = AssetListViewType.list | AssetListViewType.column;

export enum AssetListSortType {
  releaseDate = 'releaseDate',
  status = 'status',
  lastUpdated = 'lastUpdated',
  alphabetical = 'alphabetical',
}

export type AssetListSortTypes =
  | AssetListSortType.releaseDate
  | AssetListSortType.status
  | AssetListSortType.lastUpdated
  | AssetListSortType.alphabetical;

export enum ExportOrientationType {
  landscape = 'landscape',
  portrait = 'portrait',
}

export type ExportOrientationTypes = ExportOrientationType.landscape | ExportOrientationType.portrait;

export enum NumberItemsPerPageType {
  landscape = 9,
  portrait = 27,
}

export type NumberItemsPerPageTypes = NumberItemsPerPageType.landscape | NumberItemsPerPageType.portrait;
